import { StudioActionTypes } from './studio.types';

export const initialState = {
  account: null,
  credits: null,
  product: null,
  logosInfo: null,
  loading: false,
  showLoadingError: false,
  accessTracking: {
    status: null,
  },
  formCheck: {
    answered: undefined,
  },
  formSend: [],
  forMe: {
    list: [],
    loading: false,
    status: null,
  },
  templates: {},
  templatesLoading: false,
  available: undefined,
  listLogos: [],
  products: {
    data: null,
    loading: false,
    status: null,
  },
  provisionFree: {
    loading: false,
    status: null,
  },
  logoDownloadLoading: [],
  documentCreationLoading: false,
};

const studioReducer = (state = initialState, action) => {
  switch (action.type) {
    case StudioActionTypes.STUDIO_ACCOUNT_SET: {
      const {
        account,
        credits,
        product,
      } = action.payload;
      const logosInfo = action.payload.logos_info;
      return {
        ...state,
        account,
        credits,
        product,
        logosInfo,
      };
    }
    case StudioActionTypes.STUDIO_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_ACCOUNT_FAILURE: {
      return {
        ...state,
        showLoadingError: true,
      };
    }
    case StudioActionTypes.STUDIO_ACCOUNT_REQUEST: {
      return {
        ...state,
        showLoadingError: false,
      };
    }
    case StudioActionTypes.STUDIO_ACCESS_TRACKING_SUCCESS: {
      return {
        ...state,
        accessTracking: {
          ...state.accessTracking,
          status: 'success',
        },
      };
    }
    case StudioActionTypes.STUDIO_ACCESS_TRACKING_FAILURE: {
      return {
        ...state,
        accessTracking: {
          ...state.accessTracking,
          status: 'failure',
        },
      };
    }
    case StudioActionTypes.STUDIO_FORM_CHECK_REQUEST: {
      return {
        ...state,
        showLoadingError: false,
      };
    }
    case StudioActionTypes.STUDIO_FORM_SEND_FAILURE:
    case StudioActionTypes.STUDIO_FORM_CHECK_FAILURE: {
      return {
        ...state,
        showLoadingError: true,
      };
    }
    case StudioActionTypes.STUDIO_FORM_CHECK_SET: {
      return {
        ...state,
        formCheck: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_FORM_SEND_REQUEST: {
      return {
        ...state,
        showLoadingError: false,
        formSend: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_FORM_SEND_SET: {
      return {
        ...state,
        formSend: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_SET_TEMPLATES_FOR_ME: {
      return {
        ...state,
        forMe: {
          ...state.forMe,
          list: action.payload,
          loading: false,
          status: null,
        },
      };
    }
    case StudioActionTypes.STUDIO_GET_TEMPLATES_FOR_ME_SUCCESS: {
      return {
        ...state,
        forMe: {
          ...state.forMe,
          loading: false,
          status: 'success',
        },
      };
    }
    case StudioActionTypes.STUDIO_GET_TEMPLATES_FOR_ME_FAILURE: {
      return {
        ...state,
        forMe: {
          ...state.forMe,
          loading: false,
          status: 'failure',
        },
      };
    }
    case StudioActionTypes.STUDIO_GET_TEMPLATES_FOR_ME_LOADING: {
      return {
        ...state,
        forMe: {
          ...state.forMe,
          loading: action.payload,
        },
      };
    }
    case StudioActionTypes.STUDIO_GET_TEMPLATES_SET: {
      return {
        ...state,
        templates: {
          ...state.templates,
          ...action.payload,
        },
      };
    }
    case StudioActionTypes.STUDIO_GET_TEMPLATES_LOADING: {
      return {
        ...state,
        templatesLoading: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_GET_TEMPLATES_RESET: {
      return {
        ...state,
        templates: { ...initialState.templates },
      };
    }
    case StudioActionTypes.STUDIO_PRODUCTS_SET: {
      return {
        ...state,
        products: {
          ...state.products,
          data: action.payload,
        },
      };
    }
    case StudioActionTypes.STUDIO_PRODUCTS_LOADING: {
      return {
        ...state,
        products: {
          ...state.products,
          loading: action.payload,
        },
      };
    }
    case StudioActionTypes.STUDIO_PRODUCTS_SUCCESS: {
      return {
        ...state,
        products: {
          ...state.products,
          status: 'success',
        },
      };
    }
    case StudioActionTypes.STUDIO_PRODUCTS_FAILURE: {
      return {
        ...state,
        products: {
          ...state.products,
          status: 'failure',
        },
      };
    }
    case StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_LOADING: {
      return {
        ...state,
        provisionFree: {
          ...state.provisionFree,
          loading: action.payload,
        },
      };
    }
    case StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_SUCCESS: {
      return {
        ...state,
        provisionFree: {
          ...state.provisionFree,
          status: 'success',
        },
      };
    }
    case StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_FAILURE: {
      return {
        ...state,
        provisionFree: {
          ...state.provisionFree,
          status: 'failure',
        },
      };
    }
    case StudioActionTypes.STUDIO_DOCUMENT_CREATION_LOADING: {
      return {
        ...state,
        documentCreationLoading: action.payload,
      };
    }
    default:
      return state;
  }
};

export default studioReducer;
